(function($) {
  $(document).on('submit', function(e) {
    const { target, originalEvent = {} } = e;

    // button has the potential to be double clicked making the code below run twice (bad)
    if ($(target).find('.sq-button-inactive').length) {
      return;
    }

    const submit = originalEvent.submitter,
      button = document.createElement('button');

    // if the form button does not have a Squiz class don't do stuff
    if (!submit || !$(submit).hasClass('sq-form-submit')) {
      return;
    }

    // if the form is not validated don't do stuff
    if (!$(target).valid()) {
      return;
    }

    // this button will not submit the form
    $(button).attr('disabled', '');
    $(button).addClass('sq-button-inactive');
    $(button).html('Submitting <span class="sq-form-submit-loading"></span>');

    submit.after(button);
    $(submit).attr('type', 'hidden');
  });
})(jQuery);
